
<app-dialog [dialogWithInput]="dialog">

    <app-create-update-default
        #createUpdateDefaultComponent
        [service]="saveService"
        [id]="dialog.input.id"
        [findOneService]="findOneService"
        [formGroup]="formGroup"
        [hideSaveButton]="true"
        (entityLoaded)="entityLoaded($event)"
        (entitySaved)="entitySaved($event)"
        [buildPayload]="buildPayload"
        [inDialog]="true">
        <ng-template template-content>
            <app-card>
                <div class="row">
                    <app-form-field label="Nom" [required]="true" size="12">
                        <app-input-text [parentFormGroup]="formGroup" parentFormControlName="name"></app-input-text>
                    </app-form-field>
                    <app-form-field label="Couleur" [required]="true" [size]="12">
                        <app-input-color [parentFormGroup]="formGroup" parentFormControlName="color"></app-input-color>
                    </app-form-field>
                </div>
            </app-card>
        </ng-template>
    </app-create-update-default>
    <ng-container dialog-actions>
        <app-loading [loading]="createUpdateDefaultComponent.saveLoading" [showText]="false"></app-loading>
        <app-button (click)="createUpdateDefaultComponent.save()" [disabled]="!formGroup.valid" fill="solid" size="small"
                    iconName="check" label="Enregistrer" *ngIf="!createUpdateDefaultComponent.saveLoading &&
                !createUpdateDefaultComponent.loading && !createUpdateDefaultComponent.findOneError"></app-button>
    </ng-container>
</app-dialog>